import { ReactNode, useState } from 'react';
import { Image, Platform, View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useRoute } from '@react-navigation/native';
import { Footer } from '@/components/Footer';
import {
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/hooks/useResponsiveDimensions';
import { isPatientApp, isTherapistApp } from '@/config/constants';
import { IS_ANDROID } from '@/utils/platform';
import colors from '@/config/colors';
import { MAX_WIDTH, styles } from './styles';

export { MAX_WIDTH };

interface LoginLayoutProps {
  children: ReactNode;
  outerButtons?: ReactNode;
  scrollableHeader?: ReactNode;
}

export const LoginLayout = ({
  children,
  outerButtons,
  scrollableHeader,
}: LoginLayoutProps) => {
  const route = useRoute();
  const insets = useSafeAreaInsets();
  const bottomInset = IS_ANDROID ? insets.bottom : 0;
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const extraHeight = useResponsiveHeight(30);
  const responsivePadding = useResponsiveWidth(2.5);

  const showTherapistHeader = isTherapistApp && route.name === 'Login';

  return (
    <View
      style={
        showTherapistHeader
          ? { flex: 1 }
          : { flex: 1, backgroundColor: colors.newUI.therapist.bgBlue10 }
      }
    >
      {!isKeyboardVisible && !showTherapistHeader ? (
        <View style={{ height: 64, marginVertical: 12 }}>
          <Image
            source={require('@/assets/neolexon_Logo_ohneClaim.png')}
            style={{
              flex: 1,
              width: '100%',
              height: '100%',
              resizeMode: 'contain',
            }}
          />
        </View>
      ) : null}
      <KeyboardAwareScrollView
        enableOnAndroid
        extraHeight={extraHeight}
        onKeyboardDidHide={() => setIsKeyboardVisible(false)}
        onKeyboardDidShow={() => setIsKeyboardVisible(true)}
      >
        <View
          style={{ alignItems: 'center', justifyContent: 'center', flex: 1 }}
        >
          {scrollableHeader}
          <View
            style={[
              styles.layoutChildrenContainer,
              {
                padding: isPatientApp ? 40 : responsivePadding,
              },
            ]}
            role={Platform.OS === 'web' ? 'form' : undefined}
          >
            {children}
          </View>
          {outerButtons ? (
            <View style={{ maxWidth: MAX_WIDTH, width: '100%', flex: 1 }}>
              {outerButtons}
            </View>
          ) : null}
        </View>
      </KeyboardAwareScrollView>
      {!isKeyboardVisible && (
        <View style={{ paddingHorizontal: 24, paddingBottom: bottomInset }}>
          <Footer />
        </View>
      )}
    </View>
  );
};
